<template>
    <div class="add-user-box">
        <div class="pwd-wrap-tb gai top">
            <div class="pwd-lt">账&nbsp;&nbsp;号:</div>
            <input type="text" v-model="newaccount" class="pwd-rt"/>
        </div>
        <div class="pwd-wrap-tb gai">
            <div class="pwd-lt">密&nbsp;&nbsp;码:</div>
            <input type="password" v-model="newpwd" class="pwd-rt"/>
        </div>
        <div class="pwd-wrap-btn">
            <span class="pwd-btn" @click="saveAddUser">登录</span>
            <span class="pwd-btn cancelcount" @click="closeAddUserDom">取消</span>
        </div>
    </div>
</template>

<script>
    export default {
        name: "BaseHeaderAddUser",
        methods: {
            closeAddUserDom() {
                this.$emit('closeAddUser', true)
            },
            saveAddUser() {
                if (this.newaccount === '' || this.newpwd === '') {
                    this.$message.error('不能为空');
                    return false;
                }
                // 新账户登录
                this.$api.loginApi(this.newaccount, this.newpwd).then((res) => {
                    if (+res.data.code === 200) {
                        // 本地化登录信息
                        this.$message({
                            message: '添加账户成功',
                            type: 'success'
                        });
                        this.$store.commit('SET_LOGIN', {
                            rememberMe: this.rememberMe,
                            user: res.data.data
                        });
                    } else {
                        this.$message.error(res.data.msg);
                    }
                });

                this.$emit('closeAddUser', 'suc')
            }
        },
        data: function () {
            return {
                newaccount: '',
                newpwd: ''
            }
        }
    }
</script>

<style scoped>
    .add-user-box {
        overflow: hidden;
    }
</style>
